import { render, staticRenderFns } from "./TableGrade.vue?vue&type=template&id=6c6ca64e"
import script from "./TableGrade.vue?vue&type=script&lang=js"
export * from "./TableGrade.vue?vue&type=script&lang=js"
import style0 from "./TableGrade.vue?vue&type=style&index=0&id=6c6ca64e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports